import router from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken } from '@/utils/auth';
import { getplantForm } from '@/utils/thirdAuth';
// import { Dialog } from 'vant';
// import JsBridge from '@/utils/webViewJsBridge';

NProgress.configure({ showSpinner: false });

const whiteList = ['/login', '/', '/order/wechatPay', '/register', '/code-login', '/reset-psw', '/mine', '/course/index', '/course/group', '/course/search', '/study/index', '/course/details', '/course/course/more', '/course/promotionCourse', '/course/search/details', '/order/paySuccess', '/order/payFail', '/order/payProcess', '/setting/agreements', '/exchange/thirdlogin', '/exchange/blanket', '/study/course', '/campus/index'];
const thirdList = ['/exchange/center', '/exchange/list', '/exchange/exchange'];

router.beforeEach((to, from, next) => {
  console.log(router);
  NProgress.start();
  console.log(to);
  console.log(from);
  let query;
  if (from.path === '/order/wechatPay' || from.path === '/order/PaySuccess' || from.path === '/order/PayProcess') {
    const xsid = localStorage.getItem('xsid');
    const frontCartCampusList = JSON.parse(localStorage.getItem('frontCartCampusList'));
    // alert(xsid);
    if (xsid) {
      let campusId;
      // alert(xsid);
      // alert(localStorage.getItem('frontCartCampusList'));
      // alert(frontCartCampusList);
      if (frontCartCampusList && frontCartCampusList.length > 0) {
        let obj = frontCartCampusList.find(item => item.id === ~~xsid);
        // alert(JSON.stringify(obj));
        campusId = obj.campusId;
      }
      // alert(campusId);
      if (campusId) {
        query = { code: campusId };
      }
      const transitionTo = router.history.transitionTo; // 临时存储底层方法
      router.history.transitionTo = function(location, onComplete, onAbort) {
        // console.log('location', location);
        let hasCode = false;
        if (location.query) {
          if (location.query.redirect) {
            console.log(location.query.redirect);
            if (location.query.redirect.indexOf('code=') > -1) {
              hasCode = true;
            }
          }
        }
        // console.log('hasCode', hasCode);
        if (hasCode) {
          location = typeof location === 'object' ? { ...location, query: { ...location.query }} : { path: location };
        } else {
          location = typeof location === 'object' ? { ...location, query: { ...location.query, ...query }} : { path: location, query };
        }
        transitionTo.call(router.history, location, onComplete, onAbort);
      };
    }
  } else
  if (thirdList.indexOf(to.path) === -1 && to.path !== '/order/wechatPay') {
    if (from.query.code !== undefined) {
      query = { code: from.query.code };
    } else {
      query = { code: to.query.code };
    }
    const transitionTo = router.history.transitionTo; // 临时存储底层方法
    router.history.transitionTo = function(location, onComplete, onAbort) {
      // console.log('location', location);
      let hasCode = false;
      if (location.query) {
        if (location.query.redirect) {
          console.log(location.query.redirect);
          if (location.query.redirect.indexOf('code=') > -1) {
            hasCode = true;
          }
        }
      }
      // console.log('hasCode', hasCode);
      if (hasCode) {
        location = typeof location === 'object' ? { ...location, query: { ...location.query }} : { path: location };
      } else {
        location = typeof location === 'object' ? { ...location, query: { ...location.query, ...query }} : { path: location, query };
      }
      transitionTo.call(router.history, location, onComplete, onAbort);
    };
  }

  if (getToken()) {
    /* has token*/
    // 如果在三方名单内
    if (thirdList.indexOf(to.path) !== -1) {
      if (getplantForm()) {
        console.log(getplantForm(), 1111);
        next();
      } else {
        next({ path: '/exchange/blanket' });
        NProgress.done();
      }
    } else {
      if (to.path === '/login') {
        next({ path: '/' });
        NProgress.done();
      } else {
        next();
      }
    }

    // if (to.path === '/exchange/center') {
    //   if (window.navigator.userAgent.indexOf('MKH') === -1) {
    //     JsBridge.callHandler('jsBack', function(data) {
    //       console.log(data);
    //     });
    //   }
    // }
  } else {
    if (thirdList.indexOf(to.path) !== -1) {
      if (getplantForm()) {
        console.log(getplantForm(), 1111);
        next();
      } else {
        next({ path: '/exchange/blanket' });
        NProgress.done();
      }
    } else {
      // 没有token
      if (whiteList.indexOf(to.path) !== -1) {
        // 在免登录白名单，直接进入
        next();
      } else {
        next(`/login?redirect=${to.fullPath}`); // 否则全部重定向到登录页
        NProgress.done();
      }
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});



// WEBPACK FOOTER //
// ./src/permission.js